exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.my_library_save_changes_modal__wrapper--gG50A {\n\twidth: 100%;\n\theight: 95%;\n\tmax-height: 550px;\n\tdisplay: inline-block;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "my_library_save_changes_modal__wrapper--gG50A"
};